var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
let FrameSpecification = class FrameSpecification extends Vue {
    get frameDescription() {
        if (this.hasMount) {
            return `${this.frameSize.name} to fit ${this.itemSize.name} item`;
        }
        return `${this.itemSize.name} (No Mount)`;
    }
};
__decorate([
    Prop(Object)
], FrameSpecification.prototype, "itemSize", void 0);
__decorate([
    Prop(Object)
], FrameSpecification.prototype, "frameSize", void 0);
__decorate([
    Prop(Object)
], FrameSpecification.prototype, "length", void 0);
__decorate([
    Prop(Boolean)
], FrameSpecification.prototype, "hasMount", void 0);
__decorate([
    Prop(Object)
], FrameSpecification.prototype, "mount", void 0);
__decorate([
    Prop(Object)
], FrameSpecification.prototype, "glazing", void 0);
__decorate([
    Prop(String)
], FrameSpecification.prototype, "fixings", void 0);
__decorate([
    Prop(String)
], FrameSpecification.prototype, "unitPrice", void 0);
__decorate([
    Prop(Object)
], FrameSpecification.prototype, "validation", void 0);
FrameSpecification = __decorate([
    Component
], FrameSpecification);
export default FrameSpecification;
